import axios from 'axios';
import {baseUrl} from "../utilities/config";

export const getStudentInformation = (url) => {

    let config = {
        method: 'get',
        url: `${baseUrl}${url}`,
        headers: {
            'Content-Type': 'application/json'
        }
    };

    return axios(config)
        .then(function (response) {
            return response
        })
        .catch(function (error) {
            return error.response;
        });

}
export const postStudentInformation = (data) => {

    let config = {
        method: 'post',
        url: `${baseUrl}student`,
        headers: {
            'Content-Type': 'application/json'
        },
        data : data
    };

    return axios(config)
        .then(function (response) {
            return response
        })
        .catch(function (error) {
        return error.response;
        });

}